/**
 * 图片资源库 API
 */
import api from './api';

export interface ImageCategory {
  id: number;
  name: string;
  parent_id: number | null;
  sort_order: number;
  image_count: number;
  is_default: boolean;
  children: ImageCategory[];
}

export interface ImageAsset {
  id: number;
  filename: string;
  original_name: string;
  file_path: string;
  file_size: number;
  mime_type: string;
  width: number | null;
  height: number | null;
  category_id: number;
  category_name: string;
  ai_description?: string;
  ai_tags?: string[];
  is_analyzed: boolean;
  created_at: string;
}

export interface PaginatedImages {
  items: ImageAsset[];
  total: number;
  page: number;
  page_size: number;
}

export const mediaApi = {
  // ── 分类 ──
  getCategoriesTree: () =>
    api.get<ImageCategory[]>('/api/media/categories/tree'),

  createCategory: (data: { name: string; parent_id?: number }) =>
    api.post('/api/media/categories', data),

  updateCategory: (id: number, data: { name?: string; parent_id?: number }) =>
    api.put(`/api/media/categories/${id}`, data),

  deleteCategory: (id: number) =>
    api.delete(`/api/media/categories/${id}`),

  // ── 图片 ──
  upload: (files: File[], category_id?: number, onProgress?: (pct: number) => void) => {
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));
    const params: any = { auto_analyze: 'true' };
    if (category_id) params.category_id = String(category_id);
    return api.post('/api/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params,
      onUploadProgress: onProgress
        ? (e) => { if (e.total) onProgress(Math.round((e.loaded * 100) / e.total)); }
        : undefined,
    });
  },

  listImages: (params: {
    page?: number;
    page_size?: number;
    category_id?: number;
    q?: string;
    is_analyzed?: boolean;
    sort_by?: string;
  }) => api.get<PaginatedImages>('/api/media/images', { params }),

  getImage: (id: number) =>
    api.get<ImageAsset>(`/api/media/images/${id}`),

  updateImage: (id: number, data: {
    category_id?: number;
    original_name?: string;
    ai_description?: string;
    ai_tags?: string[];
  }) => api.put(`/api/media/images/${id}`, data),

  deleteImage: (id: number) =>
    api.delete(`/api/media/images/${id}`),

  analyzeImage: (id: number) =>
    api.post(`/api/media/images/${id}/analyze`),
};
